<template>
  <div>
    <PageAllow controller="ThirdAccountInfo" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          <span>
            {{ $t("HuifuAccount.bindCard.newInfo") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="$router.push('/huifu')"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("HuifuAccount.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <!-- 结算账户类型 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("HuifuAccount.bindCard.card_type") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="cardInfo.card_type">
                    <v-radio
                            v-for="type in cardTypeItems"
                            class="mt-n2"
                            :key="type.value"
                            :label="`${type.text}`"
                            :value="type.value"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- 结算账户名 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("HuifuAccount.bindCard.card_name") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('HuifuAccount.bindCard.card_name')"
                          rules="required"
                  >
                    <v-text-field
                            single-line
                            v-model="cardInfo.card_name"
                            :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 结算账号 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("HuifuAccount.bindCard.card_no") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('HuifuAccount.bindCard.card_no')"
                          rules="required"
                  >
                    <v-text-field
                            single-line
                            v-model="cardInfo.card_no"
                            :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 银行所在省市 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("HuifuAccount.bindCard.bank_detail") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <CitiesHFBankSelectGroup
                          :masterItem="cardInfo"
                          @provinceCode="cardInfo.prov_id = $event"
                          @cityCode="cardInfo.area_id = $event"
                  />
                </v-col>
              </v-row>
              <!-- 银行总行编码 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("HuifuAccount.bindCard.bank_code") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('HuifuAccount.bindCard.bank_code')"
                          rules="required"
                  >
                    <v-text-field
                            single-line
                            v-model="cardInfo.bank_code"
                            :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  <div><a href="https://paas.huifu.com/partners/api/#/csfl/api_csfl_yhbm" target="_blank" rel="noopener">点击查看银行编码</a>&nbsp;&nbsp;示例值：01040000</div>
                </v-col>
              </v-row>
              <!-- 支行联行号 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("HuifuAccount.bindCard.branch_code") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('HuifuAccount.bindCard.branch_code')"
                          rules="required"
                  >
                    <v-text-field
                            single-line
                            v-model="cardInfo.branch_code"
                            :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  <div><a href="https://paas.huifu.com/partners/api/#/csfl/api_csfl_yhzhbm" target="_blank" rel="noopener">点击查看支行联行号</a>&nbsp;&nbsp;示例值：103124075619</div>
                </v-col>
              </v-row>
              <!-- 支行名称 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("HuifuAccount.bindCard.branch_name") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('HuifuAccount.bindCard.branch_name')"
                          rules="required"
                  >
                    <v-text-field
                            single-line
                            v-model="cardInfo.branch_name"
                            :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  <div><a href="https://paas.huifu.com/partners/api/#/csfl/api_csfl_yhzhbm" target="_blank" rel="noopener">点击查看支行名称</a>&nbsp;&nbsp;示例值：中国农业银行股份有限公司唐山陶瓷市场分理处</div>
                </v-col>
              </v-row>
              <!-- 持卡人证件类型 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("HuifuAccount.bindCard.cert_type") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('HuifuAccount.bindCard.cert_type')"
                          rules="required"
                  >
                    <v-autocomplete
                            color="primary"
                            hide-no-data
                            v-model="certTypeSelected"
                            clearable
                            :items="$consts.legal_cert_type"
                            item-text="text"
                            item-value="value"
                            item-disabled="disabled"
                            return-object
                            :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 持卡人证件号码 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("HuifuAccount.bindCard.cert_no") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('HuifuAccount.bindCard.cert_no')"
                          rules="required"
                  >
                    <v-text-field
                            single-line
                            v-model="cardInfo.cert_no"
                            :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 证件有效期 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("HuifuAccount.bindCard.cert_date") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-row class="pl-3">
                    <v-checkbox
                            v-model="certValidityTypeChecked"
                            :label="$t('HuifuAccount.bindCard.cert_validity_type')"
                            :true-value="1"
                            :false-value="0"
                    ></v-checkbox>
                  </v-row>
                  <v-row class="pl-3">
                    <v-col cols="5" md="5">
                      <ValidationProvider
                              v-slot="{ errors }"
                              :name="$t('HuifuAccount.bindCard.cert_begin_date')"
                              rules="required"
                      >
                        <SearcherDatetime
                                class="my-n2"
                                v-model="certBeginDate"
                                type="date"
                                single-line
                                dense
                                hide-details
                                hide-icon
                                required
                                :errors="errors"
                        >
                          <template v-slot:message="{ key, message }">
                            <div :class="key == 0 ? 'danger--text' : ''">
                              {{ message }}
                            </div>
                          </template>
                        </SearcherDatetime>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="1" class="text-center">~</v-col>
                    <v-col cols="5" md="5">
                      <ValidationProvider
                              v-slot="{ errors }"
                              :name="$t('HuifuAccount.bindCard.cert_end_date')"
                              :rules="(certValidityTypeChecked == 0) ? 'required' : ''"
                      >
                        <SearcherDatetime
                                class="my-n2"
                                v-model="certEndDate"
                                type="date"
                                single-line
                                dense
                                hide-details
                                :disabled="(certValidityTypeChecked == 1)"
                                hide-icon
                                required
                                :errors="errors"
                        >
                          <template v-slot:message="{ key, message }">
                            <div :class="key == 0 ? 'danger--text' : ''">
                              {{ message }}
                            </div>
                          </template>
                        </SearcherDatetime>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 银行卡绑定手机号 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("HuifuAccount.bindCard.mp") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('HuifuAccount.bindCard.mp')"
                          rules="required"
                  >
                    <v-text-field
                            single-line
                            v-model="cardInfo.mp"
                            :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 上传营业执照 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("HuifuAccount.bindCard.license_img") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-card v-if="card_img" max-width="240">
                    <v-img
                            :src="card_img"
                            @click.stop="$showFullscreenImages([card_img])"
                    >
                      <v-tooltip right v-if="savable && card_img">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="secondary"
                                  class="pa-2 float-right"
                                  @click.stop="card_img = null"
                          >
                            fa-times
                          </v-icon>
                        </template>
                        <span> {{ $t("Material.delImg") }}</span>
                      </v-tooltip>
                    </v-img>
                  </v-card>
                  <v-file-input
                          ref="card_img_file"
                          v-if="savable"
                          show-size
                          prepend-icon="fa-camera"
                          accept="image/png, image/jpeg"
                          persistent-hint
                          :placeholder="$t('Material.imgPlaceholder')"
                          :hint="$t('Material.imgHint')"
                          :rules="imgRules"
                          v-model="card_img_file"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- 右侧按钮 -->
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="$router.push('/huifu')"
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$t("HuifuAccount.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="success"
                  block
                  :disabled="loading"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$t("HuifuAccount.bindCard.newInfo")]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Required from "@/components/plugins/Required";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Consts from "@/consts.js";
import CitiesHFBankSelectGroup from "@/components/plugins/CitiesHFBankSelects";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import HfdgInterface from "@/api/hfdgInterface";
import ThirdAccountInfo from "@/api/third-account-info"

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    Required,
    ValidationObserver,
    ValidationProvider,
    CitiesHFBankSelectGroup,
    SearcherDatetime,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.thirdPayment"),
          disabled: false,
          href: "/huifu",
        },
        {
          text: i18n.t("Nav.huifuAccount"),
          disabled: true,
          href: "/huifu",
        },
        {
          text: i18n.t("HuifuAccount.bindCard.newInfo"),
          disabled: true,
          href: "/huifu",
        },
      ];
    },
    isNew() {
      return this.mode == "new";
    },
    savable() {
      return this.mode == "new";
    },
    cardTypeItems() {
      return Consts.huifu.huifu_card_type;
    },


    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    mode: '',
    huifuAccount: {},
    cardInfo:{},
    certValidityTypeChecked: 0,
    certBeginDate: null,
    certEndDate: null,
    certTypeSelected: null,
    card_img: "",
    card_img_file: null,
    imgRules: [
      (value) => !value || value.size < 5000000 || i18n.t("HuifuAccount.imgHint"),
    ],
  }),

  mounted() {
    this.mode = 'new'
    this.cardInfo.card_type = 0
    this.getThirdAccountFromAPI(this.$route.params.id);
  },

  methods: {
    getThirdAccountFromAPI(id) {
      ThirdAccountInfo.fetchOne(id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.huifuAccount = response.data.third_account;
                }
              }.bind(this)
      );
    },
    submit() {
      // this.$store.dispatch("fullscreenLoading");
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.card_img_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      if (!this.card_img_file) {
        this.$snackbar.error(
                i18n.t("HuifuAccount.bindCard.file_error_message")
        );
        return;
      }

      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            //整理提交数据
            this.cardInfo.cert_begin_date = this.huifuDateFormat(this.certBeginDate, true);
            this.cardInfo.cert_end_date = this.huifuDateFormat(this.certEndDate, true);
            this.cardInfo.cert_validity_type = this.certValidityTypeChecked;
            let submit_data = {
              huifu_id: this.huifuAccount.huifu_id,
              card_info: this.cardInfo,
              cash_config: [{
                  cash_type: "T1",
                  fix_amt: "1"
                }],
              file_list: []
            };

            if (this.card_img_file) {
              // 上传入驻文件 F07:营业执照
              let imgResponse = await HfdgInterface.HFFileUpload(this.card_img_file, "F07");
              if (imgResponse.data.status.isOK()) {
                // submit_data.file_list = imgResponse.data.file
                submit_data.file_list.push(imgResponse.data.file)
                HfdgInterface.bindCard(submit_data).then(
                        function (response) {
                          if (response.data.status.isOK()) {
                            this.$snackbar.success(i18n.t("MaterialOrderRule.Messages.saveSuccess"));
                            this.$router.replace("/huifu");
                          }
                          this.$store.dispatch("fullscreenLoadingStop");
                        }.bind(this)
                ).catch(
                        function () {
                          this.$store.dispatch("fullscreenLoadingStop");
                        }.bind(this)
                );
              }
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    huifuDateFormat(date, isToHuifu = false) {
      if (date) {
        if (isToHuifu) {
          return date.replaceAll("-", "");
        }else {
          return date.slice(0, 4) + '-' + date.slice(4, 6) + '-' + date.slice(6)
        }
      }
      return null
    }
  },

  watch: {
    certTypeSelected: {
      deep: true,
      handler() {
        if (this.certTypeSelected) {
          if (this.certTypeSelected.value) {
            this.cardInfo.cert_type = this.certTypeSelected.value;
          }else {
            this.cardInfo.cert_type = this.certTypeSelected;
          }
        }else {
          this.cardInfo.cert_type = null;
        }
      }
    },
    certValidityTypeChecked: {
      deep: true,
      handler() {
        this.cardInfo.cert_validity_type = this.certValidityTypeChecked
        if (this.certValidityTypeChecked) {
          this.certEndDate = null
        }
      }
    },
    card_img_file: {
      handler() {
        if (this.card_img_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.card_img_file);
          let that = this;
          reader.onload = function () {
            that.card_img = this.result;
          };
        }else {
          this.card_img = null;
        }
      },
    },
    card_img: {
      handler() {
        if (!this.card_img) {
          this.card_img_file = null;
        }
      },
    },
  }
};
</script>